import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, FileText, TrendingUp, AlertTriangle, Calculator, MessageSquare } from "lucide-react";
import { MarketingLayout, Section } from "@/components/marketing/MarketingLayout";
import { Button } from "@/components/ui/button";

const INPUTS = ["Drawings", "BOQ", "Budget", "Documents", "Materials", "Progress", "Quality", "Payments", "Site reports", "Conversations"];
const OUTPUTS = [
  { icon: TrendingUp, t: "Insights & Predictions" },
  { icon: AlertTriangle, t: "Risk & Delay Alerts" },
  { icon: Calculator, t: "Cost Optimization" },
  { icon: FileText, t: "Automated Reports" },
  { icon: MessageSquare, t: "Natural Language Q&A" },
  { icon: Sparkles, t: "Project Assistant" },
];

export default function Intelligence() {
  const nav = useNavigate();
  return (
    <MarketingLayout>
      <section className="bg-sp-navy text-white sp-blueprint">
        <div className="sp-container py-24 lg:py-32 text-center">
          <div className="sp-eyebrow mb-4">Sitepar Intelligence</div>
          <h1 className="text-4xl lg:text-6xl font-bold tracking-tight leading-tight max-w-4xl mx-auto">
            Construction has data.<br /><span className="text-sp-orange">Sitepar gives it intelligence.</span>
          </h1>
          <p className="mt-6 text-lg text-white/65 max-w-2xl mx-auto">AI that understands your project, your drawings, your site and your goals — grounded in real data through a structured context layer, never hallucinated numbers.</p>
          <Button data-testid="intelligence-cta" onClick={() => nav("/register")} className="mt-8 bg-sp-orange hover:bg-sp-orangedark rounded-full h-12 px-7">Try the Copilot</Button>
        </div>
      </section>

      <Section dark>
        <div className="grid lg:grid-cols-3 gap-10 items-center">
          <div>
            <div className="sp-eyebrow mb-4">Understands</div>
            <div className="space-y-2">
              {INPUTS.map((i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-white/75"><span className="h-1.5 w-1.5 rounded-full bg-sp-orange" />{i}</div>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="h-28 w-28 rounded-full bg-sp-orange/10 border border-sp-orange/40 flex items-center justify-center animate-pulse-ring">
              <div className="h-16 w-16 rounded-full bg-sp-orange flex items-center justify-center"><Sparkles className="h-7 w-7 text-white" /></div>
            </div>
            <div className="mt-4 font-semibold">Sitepar Intelligence</div>
          </div>
          <div>
            <div className="sp-eyebrow mb-4">Delivers</div>
            <div className="space-y-2.5">
              {OUTPUTS.map((o) => (
                <div key={o.t} className="flex items-center gap-3 text-sm text-white/85 sp-glass rounded-lg px-4 py-2.5">
                  <o.icon className="h-4 w-4 text-sp-orange" />{o.t}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Section>
    </MarketingLayout>
  );
}
